import { BatchProposalEntriesRequestBody, BatchProposalStats } from '@blk/aw-bff-typescript-models';
import { AxiosResponse, CancelToken } from 'axios';
import { awBffApi } from './Base';

export function postFetchBatchProposalStats(
  request: BatchProposalEntriesRequestBody,
  cancelToken?: CancelToken
): Promise<AxiosResponse<BatchProposalStats[]>> {
  const path = '/proposal/proposal-entries/batch-stats';
  return awBffApi.post<BatchProposalStats[]>(path, request, { cancelToken });
}
